import { CONTRACTS_INBOX, LOGIN } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import { PER_PAGE_OPTION_2 } from '../../constants/admin/tables';

const initialState = {
    fetched: false,
    fetching: false,
    page: 1,
    totalPages: 0,
    pageSize: PER_PAGE_OPTION_2,
    list: []
};

function inbox(state = initialState, action) {
    switch (action.type) {
        case CONTRACTS_INBOX.FETCH_START:
            return { ...state, fetching: true };
        case CONTRACTS_INBOX.UPDATE:
            return { ...state, [action.field]: action.value };
        case CONTRACTS_INBOX.FETCH_OK:
            return {
                ...state,
                totalPages: Math.ceil(action.total / action.pagesize),
                fetching: false,
                fetched: true,
                list: action.contracts
            };
        case LOCATION_CHANGE:
        case LOGIN.CANCEL:
            return initialState;
        default:
            return state;
    }
}

export default inbox;
